import {list} from "custom/demo/requests/admin/decks";
import AdminList from "custom/demo/helpers/admin/list";

const actions = {edit: true, list, new: true};

const columns = [
  {key: "position", label: "Position"},
  {key: "key", label: "Key"},
  {key: "name", label: "Name"},
  {key: "hidden", label: "Hidden"},
  {key: "color", label: "Color"},
  {key: "image_pack", label: "Image Pack"},
  {key: "icon", label: "Icon"},
  {key: "custom_share_images", label: "Custom Share Images"}
];

export default function List() {
  return <AdminList actions={actions} columns={columns} name="Deck" path="/admin/decks" />;
}
